import React, { useEffect, useState } from "react";
import SearchIconVm from "../../assets/icon_components/searchIcon";
import { TextField, InputAdornment, useMediaQuery } from "@mui/material";

export const SearchBox = ({
    placeholder = "Search here...",
    handleSearch = () => false,
    value = "",
    title = "",
    iconPosition = "end",
    height = "42px",
    width = "270px",
    onClick,
    // Animation props
    animatedItems = [],
    staticText = "Search by ",
    animationInterval = 3000,
    enableAnimation = false,
}) => {
    const isSmallScreen = useMediaQuery('(max-width:765px)');
    const [currentIndex, setCurrentIndex] = useState(0);
    
    const resolveTitle = isSmallScreen ? 'Search' : title;
    const resolveplaceholder = isSmallScreen ? 'Search' : placeholder;
    const resolvedWidth = isSmallScreen ? '100%' : width;
    const adornmentPosition = iconPosition === "start" ? 'startAdornment' : 'endAdornment';
    // Use the same items for mobile and desktop - no truncation
    const displayItems = animatedItems;
    
    useEffect(() => {
        if (!enableAnimation || value !== "" || displayItems.length === 0) return;

        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % displayItems.length);
        }, animationInterval);

        return () => clearInterval(interval);
    }, [value, displayItems.length, animationInterval, enableAnimation]);

    return (
        <>
            <style>
                {`
                    @keyframes fadeInOut {
                        0% { 
                            opacity: 0; 
                            transform: translateY(-10px); 
                        }
                        20% { 
                            opacity: 1; 
                            transform: translateY(0); 
                        }
                        80% { 
                            opacity: 1; 
                            transform: translateY(0); 
                        }
                        100% { 
                            opacity: 0; 
                            transform: translateY(10px); 
                        }
                    }
                    
                    .animated-text {
                        animation: fadeInOut ${animationInterval}ms ease-in-out infinite;
                    }
                `}
            </style>
            <div style={{ position: 'relative', width: resolvedWidth }}>
                <TextField
                    id="search-navbar"
                    placeholder={enableAnimation ? "" : resolveplaceholder}
                    title={resolveTitle ?? ""}
                    value={value ?? ""}
                    onChange={(e) => handleSearch(e.target.value)}
                    onClick={onClick ?? (() => { })}
                    autoComplete="off"
                    autoCapitalize="none"
                    variant="outlined"
                    size="small"
                    InputProps={{
                        [adornmentPosition]: (
                            <InputAdornment position={iconPosition}>
                                <SearchIconVm />
                            </InputAdornment>
                        ),
                        sx: {
                            height: height ?? "40px",
                            padding: "8px",
                            paddingLeft: isSmallScreen && enableAnimation ? "8px" : "8px",
                        },
                    }}
                    sx={{
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "4px",
                            backgroundColor: "white",
                            border: "1px solid #D9D9D9",
                            "&.Mui-focused": {
                                borderColor: "var(--color-bg-primary-main)",
                                boxShadow: "0 0 0 1px var(--color-bg-primary-main)",
                                outline: "none",
                            },
                        },
                        "& .MuiInputBase-input": {
                            color: "black",
                            fontSize: isSmallScreen ? "0.75rem" : "0.875rem",
                            // Remove padding-left to ensure text starts at the beginning
                            paddingLeft: "0px",
                        },
                    }}
                />
                
                {/* Animated overlay text */}
                {enableAnimation && value === "" && displayItems.length > 0 && (
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '14px',
                            transform: 'translateY(-50%)',
                            pointerEvents: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            color: '#999',
                            fontSize: isSmallScreen ? '0.7rem' : '0.875rem',
                            height: '100%',
                            zIndex: 0, // Ensure it's behind the input text
                            opacity: 0.6, // Make it more subtle
                        }}
                    >
                        <span style={{ 
                            marginRight: '3px', 
                            opacity: 0.7,
                            fontWeight: 'normal',
                        }}>
                            {isSmallScreen ? "Search" : staticText}
                        </span>
                        <span
                            key={currentIndex}
                            className="animated-text"
                            style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '100px',
                            }}
                        >
                            {isSmallScreen ? displayItems[currentIndex] : `${displayItems[currentIndex]}`}
                        </span>
                    </div>
                )}
            </div>
        </>
    );
};